// import Certificado from './Index.vue'
import Permissions from "../../models/Permissions";

const Certificado = () => import("./Index.vue");

const permissions = [
  Permissions.COLABORADOR,
  Permissions.GESTOR,
  Permissions.ADMINISTRADOR,
];

export default [
  {
    path: "/certificado",
    name: "Certificado",
    component: Certificado,
    meta: {
      requiresAuth: true,
      requiresCompany: true,
      showInMenu: true,
      label: "Certificado",
      icon: "fa fa-file-o",
      group: "Arquivos",
      permissions,
    },
  },
];
